import React, { useState, useEffect, useRef } from 'react';
import { Button, Popup, ScrollView } from 'devextreme-react';
import { useDispatch, useSelector } from 'react-redux';
import Form, { EmptyItem, GroupItem, Item, Label, RequiredRule, SimpleItem, StringLengthRule } from 'devextreme-react/form';

import DataGrid, { Column, Lookup, Editing } from 'devextreme-react/data-grid';

import notify from 'devextreme/ui/notify';
import { catalogosConocidos } from '../../data/catalogos';
import { editorOptionsNumberBox, editorOptionsNumberBox2 } from '../../data/app';
import { case_insensitive_comp } from '../../utils/common';
import { closeDialogScleralClient } from '../../store/scleralsClient/scleralsClientReducer';
import { defaultItem } from '../../data/items';
import http from '../../utils/http';
import uri from '../../utils/uri';
import { ToolbarItem } from 'devextreme-react/popup';

const catalogs = [
    catalogosConocidos.MarcaLenteOftalmico,
    catalogosConocidos.ModeloLenteOftalmico,
    catalogosConocidos.MarcaLenteContacto,
    catalogosConocidos.ModeloLenteContacto,
    catalogosConocidos.TipoLente,
    catalogosConocidos.SubTipoLente,
    catalogosConocidos.Material,
    catalogosConocidos.Tratamiento,
    catalogosConocidos.Color,
    catalogosConocidos.AlturaMarco,
    catalogosConocidos.TipoMarco,
    catalogosConocidos.SubTipoMantenimiento,
    catalogosConocidos.TipoLenteContacto,
    catalogosConocidos.MarcaMarcoAro,
    catalogosConocidos.ModeloMarcoAro,
    catalogosConocidos.MarcaAccesorio,
    catalogosConocidos.MarcaLentesEsclerales,
    catalogosConocidos.ModeloLentesEsclerales,
    catalogosConocidos.TipoLentesEsclerales,
    catalogosConocidos.DisenoLenteEsclerales
]

const Nuevo = ({ clientId }) => {

    const formRef = useRef();
    const [item, setItem] = useState({ ...defaultItem });
    const [saving, setSaving] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    let dispatch = useDispatch();

    const { open, id } = useSelector((store) => store.scleralClient);

    const isNew = id === 0;

    const updateState = (data) => {

        setItem(prev => {
            return {
                ...prev,
                ...data
            };
        });

    }

    const onEyeChanged = ({ value }) => updateState({ eye: value });

    const onBrandChanged = ({ value }) => updateState({ brandId: value });

    const onModelChanged = ({ value }) => updateState({ modelId: value });

    const onModelScleralChanged = ({ value }) => updateState({ modelScleralId: value });

    const onTypeChanged = ({ value }) => updateState({ typeScleralId: value });

    const closeDialog = () => dispatch(closeDialogScleralClient());

    const guardarItem = () => {

        const { eyeBool, brandId, modelId, modelScleralId, typeScleralId, baseCurve, axis, cylinder, sphere, power, diameter, sagita, type, itemId, cost, price } = item;

        const eye = eyeBool ? 'OD' : 'OI';

        let data = { id, eye, clientId, brandId, modelId, modelScleralId, typeScleralId, baseCurve, axis, cylinder, sphere, power, diameter, sagita, type, itemId, cost, price };

        const url = uri.scleralsClient(clientId).insert;

        setSaving(true);
        http(url).asPost(data).then(() => {
            notify("Guardado", "success", 3000);
            closeDialog();
        }).finally(() => setSaving(false));

    }

    const clearItem = () => {

        setItem(prev => {
            return {
                ...defaultItem,
                lensItem: { ...defaultItem.lensItem },
                contactLensItem: { ...defaultItem.contactLensItem },
                frameItem: { ...defaultItem.frameItem },
                maintenanceItem: { ...defaultItem.maintenanceItem },
                scleralItem: { ...defaultItem.scleralItem },
                areaProductStock: { ...defaultItem.areaProductStock },
                profitPercent: 0,
                catalogs: [...prev.catalogs]
            };
        })
    }

    const loadCatalogs = async () => {

        const [_itemTypes, _catalogs] = await Promise.all([
            http(uri.itemTypes.get).asGet(),
            http(uri.catalogEntriesByNames).asPost(catalogs)
        ]);

        setItem(prev => {
            return {
                ...prev,
                itemTypes: _itemTypes,
                catalogs: _catalogs
            }
        });


    }

    const onLoad = () => {

        Promise.all([
            http(uri.itemTypes.get).asGet(),
            http(uri.catalogEntriesByNames).asPost(catalogs),
            http('scleralsclient/getbyid/' + id).asGet()
        ]).then(result => {

            const [scleralItem] = result[2];
            const { i, s } = scleralItem;

            let r = {
                ...item,
                itemTypes: result[0],
                catalogs: result[1],
                ...i,
                ...s
            };

            r.eyeBool = r.eye === 'OD';

            if (r.areaProductStock == null)
                r.areaProductStock = { price: 0, costAvg: 0 };



            setItem(r);
        });
    }

    useEffect(() => {

        if (open && id > 0)
            onLoad();
        else
            clearItem();


    }, [open]);

    useEffect(() => {
        loadCatalogs();
    }, []);

    useEffect(() => {

        const { brandId, modelId, modelScleralId, typeScleralId } = item;

        if (modelId == 139) {

            if (brandId && modelId && modelScleralId) {

                http('items/AsCatalog/Sclerals').asGet({ brandId, modelId, modelScleralId, typeScleralId:0 }).then(result => {

                    setItem(prev => {
                        return {
                            ...prev,
                            ...result
                        }
                    });

                });
            }

        } else {

            if (brandId && modelId && modelScleralId && typeScleralId) {

                http('items/AsCatalog/Sclerals').asGet({ brandId, modelId, modelScleralId, typeScleralId }).then(result => {

                    setItem(prev => {
                        return {
                            ...prev,
                            ...result
                        }
                    });

                });
            }
        }

    }, [item.brandId, item.modelId, item.modelScleralId, item.typeScleralId]);

    const title = "Nuevo Escleral";

    const dataSourceBrand = item.catalogs.filter(x => x.catalog == catalogosConocidos.MarcaLentesEsclerales);

    const dataSourceModel = item.catalogs.filter(x => x.catalog == catalogosConocidos.DisenoLenteEsclerales && x.parentId == item.brandId);

    const dataSourceModelScleral = item.catalogs.filter(x => x.catalog == catalogosConocidos.ModeloLentesEsclerales && x.parentId == item.modelId).sort(case_insensitive_comp);

    const dataSourceTypes = item.catalogs.filter(x => x.catalog == catalogosConocidos.TipoLentesEsclerales && x.parentId == item.modelId);

    const isScleral2 = item.modelId != 138;

    return (

        <Popup
            width={900}
            height={null}
            title={title}
            visible={open}
            onHiding={closeDialog}>
            <ToolbarItem
                widget="dxButton"
                location="after"
                options={{
                    text: 'Editar',
                    icon: 'edit',
                    onClick: function (e) { setCanEdit(!canEdit); }
                }}>
            </ToolbarItem>
            <ScrollView showScrollbar="onScroll">
                <Form formData={item} ref={formRef}>

                    <GroupItem cssClass="second-group" colCount={2}>
                        <SimpleItem dataField="eyeBool" editorType="dxSwitch" editorOptions={{ onValueChanged: onEyeChanged, defaultValue: true, switchedOffText: "IZQ", switchedOnText: "DER", }}>
                            <Label text="Ojo" />
                        </SimpleItem>
                    </GroupItem>

                    <GroupItem cssClass="second-group" colCount={2}>

                        <SimpleItem dataField="brandId" editorType="dxSelectBox" editorOptions={{ dataSource: dataSourceBrand, valueExpr: "id", displayExpr: "value", onValueChanged: onBrandChanged, defaultValue: null }}>
                            <Label text="Marca" />
                        </SimpleItem>

                        <SimpleItem dataField="modelId" editorType="dxSelectBox"
                            editorOptions={{
                                dataSource: dataSourceModel, valueExpr: "id", displayExpr: "value", defaultValue: null,
                                onValueChanged: onModelChanged
                            }}>
                            <Label text="Diseño de lente" />
                            <RequiredRule message="Este campo es requerido" />
                        </SimpleItem>

                        <SimpleItem dataField="modelScleralId" editorType="dxSelectBox" editorOptions={{
                            dataSource: dataSourceModelScleral, valueExpr: "id", displayExpr: "value",
                            onValueChanged: onModelScleralChanged, defaultValue: null, searchEnabled: true
                        }}>
                            <Label text="Modelo" />
                            <RequiredRule message="Este campo es requerido" />
                        </SimpleItem>

                        <SimpleItem dataField="typeScleralId" editorType="dxSelectBox"
                            editorOptions={{
                                dataSource: dataSourceTypes, valueExpr: "id", displayExpr: "value", defaultValue: null,
                                onValueChanged: onTypeChanged
                            }}>
                            <Label text="Tipo" />
                        </SimpleItem>

                        {
                            !isScleral2 &&
                            <SimpleItem dataField="baseCurve" editorType="dxNumberBox" editorOptions={{ ...editorOptionsNumberBox, readOnly: !canEdit }} ><Label text='Curva Base' /></SimpleItem>
                        }

                        {isScleral2 &&
                            <SimpleItem dataField="fltStp" editorOptions={{ ...editorOptionsNumberBox, readOnly: !canEdit }} ><Label text='Fit/Stp' /></SimpleItem>
                        }

                        <SimpleItem dataField="sagita" editorType="dxNumberBox" editorOptions={{ ...editorOptionsNumberBox2, readOnly: !canEdit }}><Label text="Sagita" /></SimpleItem>
                        <SimpleItem dataField="diameter" editorType="dxNumberBox" editorOptions={{ ...editorOptionsNumberBox2, readOnly: !canEdit }}><Label text="Diametro" /></SimpleItem>
                        <SimpleItem dataField="power" editorType="dxNumberBox" editorOptions={{ ...editorOptionsNumberBox2, readOnly: !canEdit }}><Label text="Poder" /></SimpleItem>
                        <SimpleItem dataField="description" colSpan={2} editorType="dxTextBox">
                            <Label text="Nota" />
                            <StringLengthRule max={500} message="Maximo 500 caracteres" />
                        </SimpleItem>
                    </GroupItem>

                    <GroupItem cssClass="second-group" colCount={3} caption="Sobre Refreacción">
                        <SimpleItem dataField="sphere" editorType="dxNumberBox" colSpan={1}><Label text="Esfera" /></SimpleItem>
                        <SimpleItem dataField="cylinder" editorType="dxNumberBox" colSpan={1}><Label text="Cilindro" /></SimpleItem>
                        <SimpleItem dataField="axis" editorType="dxNumberBox" colSpan={1}><Label text="Eje" /></SimpleItem>
                    </GroupItem>

                    <GroupItem cssClass="second-group" colCount={3} caption="Costos">
                        <SimpleItem dataField="cost" colSpan={1} editorType="dxNumberBox" editorOptions={{ ...editorOptionsNumberBox2 }}>
                            <Label text="Costo Com" />
                        </SimpleItem>
                        <SimpleItem dataField="price" colSpan={1} editorType="dxNumberBox" editorOptions={{ ...editorOptionsNumberBox2 }}>
                            <Label text="Precio Vta" />
                        </SimpleItem>
                    </GroupItem>
                </Form>

                <div className='footer-dialog'>
                    <Button
                        disabled={saving}
                        width={180}
                        text={saving ? 'Guardando...' : 'Guardar'}
                        type="default"
                        icon='save'
                        onClick={guardarItem}
                    />
                </div>
                <br />

            </ScrollView>
        </Popup >

    );
}

export default Nuevo;
